function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "day-fog",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#EFCC00",
  fillRule: "nonzero",
  cx: 69.5,
  cy: 67.2168866,
  rx: 42.5,
  ry: 42
}), /*#__PURE__*/React.createElement("path", {
  d: "M70,0.216886562 L70,15.2168866",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137,67.2168866 L122,67.2168866",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,67.2168866 L2,67.2168866",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118,19.2168866 L107,30.2168866",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,30.2168866 L22,19.2168866",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.8983516,102.442871 C73.5541833,101.381841 58.7689091,92.3276491 50.3379121,78.2168866 L29,78.2168866 C32.5427073,91.1133312 41.9555924,101.560708 54.3748656,106.380491 C66.7941387,111.200275 80.751299,109.822557 92,102.666495 C91.282967,102.591954 90.6153846,102.492565 89.8983516,102.442871 Z",
  id: "Path",
  fill: "#E0E0E0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54,78.2168866 L25,78.2168866",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,90.2168866 L38,90.2168866",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,103.216887 L124,103.216887",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76,115.216887 L129,115.216887",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,115.216887 L58,115.216887",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,128.216887 L104,128.216887",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,128.216887 L40,128.216887",
  id: "Path",
  stroke: "#A5A9AA",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51,90.2168866 L67,90.2168866",
  id: "Path",
  stroke: "#B9C1C6",
  strokeWidth: 3,
  strokeLinecap: "round"
})));

function SvgDayFog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "132px",
    viewBox: "0 0 139 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day-fog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayFog);
export default __webpack_public_path__ + "static/media/day-fog.eb2db366.svg";
export { ForwardRef as ReactComponent };